export default __webpack_public_path__ + "6aa5b323877d3de218ad7c309f3a2012.pdf";